import React from 'react';
import TagValuesInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '350px',
        align: 'left',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Total Items',
        dataIndex: 'tagged_item_count',
        width: '150px',
        align: 'center',
        sorter: false
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the tag value
          {item.name}
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: 'Tag Values',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Tag',
    title: 'Tag Value',
    component: props => (
      <TagValuesInput
        {...props}
        title="Tag Value"
      />
    )
  }
};

export default config;
